export function createTabIdPrefix(projectId: string, tabId: string) {
  return `${projectId}-${tabId}`.toLocaleLowerCase();
}
